import firebase from "firebase/compat/app";

const getGroupInfoById = async function(id) {
  let db = firebase.firestore();

  //get member infomation in each group
  const groupSnapshot = await db
    .collection("wellness_groups")
    .doc(id)
    .get();
  return groupSnapshot.data();
};

export default getGroupInfoById;
